<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <filtros-busqueda :empleados.sync="empleados"
                        @buscar="buscarDatosBip"/>
    </div>
    <div>

      <b-table-simple hover small caption-top stacked>
        <caption>
          <div class="text-center">Bono Individual de Productividad</div>
        </caption>
        <colgroup>
          <col>
          <col>
        </colgroup>
        <colgroup>
          <col>
          <col>
          <col>
        </colgroup>
        <colgroup>
          <col>
          <col>
        </colgroup>
        <b-thead head-variant="dark">
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td stacked-heading="Segmento de Productividad">{{ datos.segmento }}</b-td>
          </b-tr>
          <b-tr>
            <b-td stacked-heading="Bono Individual de Productividad">
              <div class="mb-4">
                <b-avatar v-if="datos.cumplio" variant="success" text=""></b-avatar>
                <b-avatar v-else variant="danger" text=""></b-avatar>
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-td colspan="7" variant="secondary" class="text-right">
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </div>
    <b-row>
      <b-col>
        <download-excel
            v-if="excel.length > 0"
            class="btn btn-primary"
            :data="excel"
            :fields="fieldsExcel"

            worksheet="My Worksheet"
            name="Bono individual.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
    </b-row>
    <div class="col">
      <b-table
          id="Pendientes"
          thead-tr-class="columnas"
          :items="datos.tabla"
          :fields="fields"
          :per-page="registrosPorPagina"
          :current-page="paginaActual"
          responsive
          stacked="md"
          class="parrafos"
          foot-clone
          no-footer-sorting
          foot-row-variant="secondary"
          show-empty>
        <template v-slot:cell(fechaSesion)="row">
          {{ row.item.fechaSesion | formatoFechaCorta }}
          --
          {{ row.item.fechaCalculoFechaProgramada | formatoFechaCorta }}
        </template>
        <template v-slot:cell(fechaPago)="row">
          {{ row.item.fechaPago|formatoFechaCorta }}
        </template>
        <template v-slot:cell(monto)="row">
          <span v-if="row.item.estabaRetenido" v-b-tooltip.hover title="'Comisión liberada'" class="text-primary" > {{ row.item.monto | moneda }}</span>
          <span v-else>{{ row.item.monto | moneda }}</span>
        </template>
        <template #foot()="row">
          {{ " " }}
        </template>
        <template #foot(tratamientio)="row">
          Total tratamientos (Ponderación):
        </template>
        <template #foot(clinica)="row">
          {{datos.ponderacion}}
        </template>
        <template #foot(diente)="row">
          Subtotal:
        </template>
        <template #foot(monto)="row">
          {{ datos.subTotal | moneda }}
        </template>
        <template #empty="scope">
          <b-col v-if="!loader">
            <b-alert v-if="datos.tabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
        </template>
      </b-table>


    </div>
    <b-col v-if="!loader">
      <b-pagination
          v-if="datos.tabla !== undefined && datos.tabla.length > 15"
          align="center"
          v-model="paginaActual"
          :total-rows="datos.tabla.length"
          :per-page="registrosPorPagina"
          aria-controls="my-table1"
      ></b-pagination>
    </b-col>

  </b-container>
</template>

<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
export default {
  components: {FiltrosBusqueda},
  props: {
    empleados: Array
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      datos: {
        segmento: null,
        ponderacion: null,
        garantia: null,
        productidad: null,
        tabla: [],
        cumplio: null,
        subTotal: 0
      },
      excel: [],
      fechai: '',
      formatted: '',
      selected: '',
      fechaf: '',
      fields: [
        {key: "idComision", label: "ID", sortable: true},
        {key: "nombreDoctorComision", label: "Empleado", sortable: true},
        {key: "idTratamiento", label: "Num. Tx", sortable: true},
        {key: "idRecibo", label: "#Recibo", sortable: true},
        {key: "fechaSesion", label: "Fecha Tx - Fecha Cálculo", sortable: true},
        {key: "fechaPago", label: "Fecha Programada Pago", sortable: true},
        {key: "idPaciente", label: "ID Paciente", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "numeroSesion", label: "Sesión", sortable: true},
        {key: "tratamientio", label: "Tratamiento", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "diente", label: "OD", sortable: true},
        {key: "monto", label: "Bono", sortable: true}
      ],
      fieldsExcel: {
        "ID": "idComision",
        "Empleado": "nombreDoctorComision",
        "Num. Tx": "idTratamiento",
        "#Recibo": "idRecibo",
        "Fecha Tx": "fechaSesion",
        "Fecha Cálculo": "fechaCalculoFechaProgramada",
        "Fecha Programada Pago": "fechaPago",
        "ID Paciente": "idPaciente",
        "Paciente": "paciente",
        "Sesión": "numeroSesion",
        "Tratamiento": "tratamientio",
        "Clinica": "clinica",
        "OD": "diente",
        "Bono": "monto"
      },
      registrosPorPagina: 15,
      paginaActual: 1,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD
    },
    buscarDatosBip(filtro) {
      this.loader = true
      this.paginaActual=1;
      this.datos = {
        segmento: null,
        ponderacion: null,
        garantia: null,
        productidad: null,
        tabla: []
      };
      this.excel = [];

      this.$http.post(this.$api + 'comisiones/comision/bono_individual_productividad', filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.datos = respuesta.data.data;
              this.excel = JSON.parse(JSON.stringify(respuesta.data.data.tabla));
              this.excel.map(value => {
                value.fechaSesion =  this.$formatoFecha(value.fechaSesion);
                value.fechaPago =  this.$formatoFecha(value.fechaPago);
                value.fechaCalculoFechaProgramada = this.$formatoFecha(value.fechaCalculoFechaProgramada);
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    }
  }
}
</script>
<style>

.break-word {
  word-wrap: break-word !important;
}
.my-divider {
  margin-top: 15px;
}


</style>
